import { defineStore } from 'pinia'
import { ref } from 'vue'

const EMULATOR_MODE_KEY = 'mm_emulator_mode'

export const useSettingsStore = defineStore('settings', () => {
  const emulatorMode = ref(localStorage.getItem(EMULATOR_MODE_KEY) === 'true')

  function setEmulatorMode(value: boolean) {
    emulatorMode.value = value
    localStorage.setItem(EMULATOR_MODE_KEY, String(value))
  }

  return { emulatorMode, setEmulatorMode }
})
